import { render, staticRenderFns } from "./ResultNotify.vue?vue&type=template&id=bf800912&scoped=true&"
import script from "./ResultNotify.vue?vue&type=script&lang=js&"
export * from "./ResultNotify.vue?vue&type=script&lang=js&"
import style0 from "./ResultNotify.vue?vue&type=style&index=0&id=bf800912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf800912",
  null
  
)

export default component.exports